import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { hideModalVerifyPhone } from 'actions/setting/bankAccount';
import styles from './style.css';

class VerifyPhoneModal extends React.Component {
  render() {
    const { showModalVerifyPhone } = this.props;

    return (
      <Modal
        show={showModalVerifyPhone}
        className={`${styles.modal}`}
        dialogClassName={`modal-dialog ${styles['modal-dialog']}`}
      >
        <Modal.Header>
          <Modal.Title>
            <span className="pull-left">Verify Phone Number</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          You need to verify your phone number in{' '}
          <strong>Account Settings &gt; Account</strong> before you can save
          your changes.
        </Modal.Body>

        <Modal.Footer>
          <button
            className={`btn mr-10px ${styles['btn-outline-dark']} ${
              styles['btn-large']
            }`}
            type="button"
            onClick={this._onClickClose}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  _onClickClose = e => {
    this.props.dispatch(hideModalVerifyPhone());
    e.preventDefault();
    e.stopPropagation();
  };
}

function mapStateToProps(state) {
  const { showModalVerifyPhone } = state.setting.bankAccount;

  return {
    showModalVerifyPhone,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VerifyPhoneModal);
